module.exports = __webpack_public_path__ + "static/media/night_flight_3.26c0cc27.jpg";